module.exports = __webpack_public_path__ + "media/אש.a781eff8.mp3";